// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-7c23a5":"bdae8f58cf42750b","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"accab6a19e96a4be","apps_stg_src_app_offer_offer-wrapper_module_ts":"5d2f3ca13dd20e38"}[chunkId] + ".js";
};